<template>
  <sui-form-field :width="field.width || 16" :error="isInvalid">
    <label v-show="field.label">
      {{field.label}}
    </label>
    <CronTasks :entity="entity" purpose="" :readonly="field.readonly" />
    <small class="errors">
      {{error}}
    </small>
  </sui-form-field>
</template>

<script>
  import FormField from '@/mixins/FormField'
  import CronTasks from '@/components/CronTasks'

  export default {
    name: 'FormServiceTasks',
    mixins: [
      FormField,
    ],
    components: {
      CronTasks
    },
  }
</script>

<style scoped>
  .errors { display: none; color: #9f3a38; }
  .error > .errors { display: block; }
</style>
